// Global state to track documents currently being pulled from Supabase.
// This allows RxDB hooks to ignore these documents and not queue them for manual sync.
export const pendingPulls = new Set<string>();
